import instance from "../../utils/axios";

// Convert payload to FormData
const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => {
    formData.append(k, v ?? "");
  });
  return formData;
};

// ✅ Save CareCell Video
export const saveCarecellVideo = async (payload) => {
  const response = await instance.post(
    "/churches/carecells/carecellvideos/save",
    toFormData(payload)
  );
  return response.data;
};

// ✅ Update CareCell Video
export const updateCarecellVideo = async (payload) => {
  const response = await instance.post(
    "/churches/carecells/carecellvideos/update",
    toFormData(payload)
  );
  return response.data;
};

// ✅ Delete CareCell Video
export const deleteCarecellVideo = async ({ _id, carecellObjId, carecellVideoObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("carecellObjId", carecellObjId);
  formData.append("carecellVideoObjId", carecellVideoObjId);

  const response = await instance.post(
    "/churches/carecells/carecellvideos/delete",
    formData
  );
  return response.data;
};

// ✅ Read CareCell Videos
export const readCarecellVideos = async (payload) => {
  const response = await instance.post(
    "/churches/carecells/carecellvideos/read",
    toFormData(payload)
  );
  return response.data;
};
